import { Balloon } from "features/無料占いBot/components/Balloon";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useEffectOnce } from "shared/hooks/useEffectOnce";
import { useScroll } from "shared/hooks/useScroll";
import tw from "twin.macro";

const activeLabelCss = tw`bg-gradient-twilight-to-r text-white`;

interface Props {
  name: string;
  text?: string;
  icon?: string;
  onClickConfirm?: () => void;
}

export const Confirm = ({ name, text, icon, onClickConfirm }: Props) => {
  const [confirm, setConfirm] = useState(null);

  const { register } = useFormContext();
  const { scrollToBottom } = useScroll();

  const handleClickConfirm = () => {
    if (onClickConfirm) onClickConfirm();
    setConfirm(true);
    scrollToBottom();
  };

  const handleClickReselect = () => {
    setConfirm(false);
  };

  useEffectOnce(scrollToBottom);

  return (
    <div tw="mb-4">
      <Balloon icon={icon}>
        {text ?? `こちらの内容でお間違いありませんか？`}
      </Balloon>
      <div tw="justify-end flex">
        <input
          {...register(name)}
          type="radio"
          value={Number(true)}
          id={`${name}-yes`}
          onClick={handleClickConfirm}
        />
        <label
          htmlFor={`${name}-yes`}
          tw="mr-2 border-card cursor-pointer"
          css={confirm == true && activeLabelCss}
        >
          はい
        </label>
        <input
          {...register(name)}
          type="radio"
          value={Number(false)}
          id={`${name}-no`}
          onClick={handleClickReselect}
        />
        <label
          htmlFor={`${name}-no`}
          tw="border-card cursor-pointer"
          css={confirm == false && activeLabelCss}
        >
          選び直す
        </label>
      </div>
    </div>
  );
};
